module.exports = __webpack_public_path__ + "static/media/artist.851fc75b.png";